import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import { BULLET_POINTS, type BulletPoint } from './constants';

const BulletPointItem: React.FC<BulletPoint> = ({ Icon, label, size }) => {
	return (
		<div className="flex items-center gap-4">
			<div className="bg-fill-information-weaker flex h-11 w-11 shrink-0 items-center justify-center rounded-full">
				<Icon className="text-icon-accent-primary" size={size} />
			</div>
			<Text size="medium" className="leading-6 wrap-break-word break-keep">
				<TypedTranslate value={label} />
			</Text>
		</div>
	);
};

export const Header: React.FC = () => {
	return (
		<>
			<div className="flex flex-col gap-3">
				<Text as="h3" className="text-size-heading-small leading-8">
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.header.subtitle" />
				</Text>
				<Text size="medium" className="leading-6 wrap-break-word break-keep">
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.header.engage_supporters" />
				</Text>
			</div>
			<div className="mt-4 flex flex-col gap-2">
				{BULLET_POINTS.map((bulletPoint) => (
					<BulletPointItem key={bulletPoint.label as unknown as string} {...bulletPoint} />
				))}
			</div>
		</>
	);
};
